import { useId } from 'react';
import FJModalClose from '../FJModalClose/FJModalClose';
import styles from './FJProgressModal.module.less';

interface FJProgressModalProps {
    /** 状态文案，如「正在下载…」 */
    title: string;
    /** 底部提示（已本地化） */
    hint?: string;
    /** 0–100 */
    progress: number;
    onClose?: () => void;
}

export default function FJProgressModal({ title, hint, progress, onClose }: FJProgressModalProps) {
    const pct = Math.round(Math.min(100, Math.max(0, progress)));
    const titleId = useId();
    return (
        <section className={styles.fj_progress_modal} aria-labelledby={title ? titleId : undefined}>
            <FJModalClose onClick={onClose} />
            <div
                className={styles.main}
                role='progressbar'
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={pct}
                aria-valuetext={`${pct}%`}
            >
                <p className={styles.percent} aria-hidden>
                    {pct}%
                </p>
                {title ? (
                    <p id={titleId} className={styles.status}>
                        {title}
                    </p>
                ) : null}
                <div className={styles.track} aria-hidden>
                    <div className={styles.fill} style={{ width: `${pct}%` }} />
                </div>
                {hint ? (
                    <p className={styles.hint} role='note'>
                        {hint}
                    </p>
                ) : null}
            </div>
        </section>
    );
}
